// extracted by mini-css-extract-plugin
module.exports = {"stickers":"CreateArStickersModal_stickers_2Aqg9","numbers":"CreateArStickersModal_numbers_1Z-qn","number":"CreateArStickersModal_number_CElBa"};